import { create } from 'zustand';

type State = {
  currDropdown: string | null;
  shortcutEnabled: boolean;
};

type Action = {
  setCurrDropdown: (dropdown: string | null) => void;
  setShortcutEnabled: (status: boolean) => void;
  clearDropdown: () => void;
  initDropdownStore: () => void;
};

const initialState: State = {
  currDropdown: null,
  shortcutEnabled: true,
};

const useDropdownStore = create<State & Action>((set, get) => ({
  ...initialState,
  setCurrDropdown(dropdown) {
    set({
      currDropdown: dropdown,
    });
  },
  setShortcutEnabled(status) {
    set({
      shortcutEnabled: status,
    });
  },
  clearDropdown() {
    set({
      currDropdown: null,
    });
  },
  initDropdownStore() {
    set(initialState);
  },
}));

export default useDropdownStore;
